
// import { Dialog } from '@headlessui/react'

import Header from './Header';

export default function Hero() {

  return (
    <div className="bg-hub-dark shadow-2xl">
      <Header></Header>



      <div className="relative px-6 lg:px-8 shadow-md border-b border-gray-300 overflow-x-hidden">
        <div className="mx-auto max-w-2xl pt-32 pb-24 sm:pt-48 lg:pt-56">
          <div className="text-center">
            <h1 className="text-2xl font-bold tracking-tight text-gray-100 sm:text-4xl">
              Collaborative legal & alternative dispute resolution practice
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-400">
              Legal | Mediation | Collaborative Services
            </p>
            <div className="mt-20 flex items-center justify-center gap-x-6">
              <a
                href="/contact"
                className="rounded-md bg-hub-primary-dark px-3.5 py-2.5 text-sm font-semibold text-hub-dark shadow-sm hover:bg-hub-primary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hub-primary-light"
              >
                Get in touch
              </a>
              <a href="/about" className="text-sm font-semibold leading-6 text-gray-400">
                Learn more <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>

        <img
          className="h-80 relative !right-0 ml-auto -mr-8 -mt-80 opacity-20"
          src="/bird.png"
          alt="resolution birdy"
        />
      </div>


    </div>
  )
}
